import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'app-edit-sub-menu-vertical-admin',
  templateUrl: './edit-sub-menu-vertical-admin.component.html',
  styleUrls: ['./edit-sub-menu-vertical-admin.component.scss']
})

export class EditSubMenuVerticalAdminComponent implements OnInit {
  @Input() data: any;
  @Output() isCancelFormEditSub = new EventEmitter();
  @Output() valueDataEdit = new EventEmitter();

  // Mảng danh sách type (none/link-page/website/link-url/category)
  listLink = [
    {
      url: 'none',
      name: 'khong'
    },
    {
      url: 'link-page',
      name: 'den_trang'
    },
    {
      url: 'website',
      name: 'lien_ket'
    },
    {
      url: 'link-url',
      name: 'URL'
    }
  ];

  listLinkPage = []; // biến chứa dữ liệu các Trang liên kết (link-page)
  isValid: boolean = true; // Biến này xác định form đã valid hay chưa (true: valid; false: chưa)

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public functionService: FunctionService,
  ) {
  }

  ngOnInit(): void {
    // Lấy dữ liệu
    this.getLinkPage();
  }

  /**
   * Lấy danh sách các Trang liên kết (link-page)
   */
  getLinkPage() {
    this.vhQueryAutoWeb.getPages_byFields({ type: { $in: ['blank', 'homepage', 'detail_category'] } }).then((pages:any) => {
      Promise.all(
        pages.map((page: any) => {
          return this.vhQueryAutoWeb.getCommonDatas_byFields({ id_page: { $eq: page._id } })
            .then((commonData) => {
              page.link = commonData[0]?.link ?? page.link;
              page.name = commonData[0]?.name ?? page.name;
              return page; // Trả về page sau khi cập nhật
            });
        })
      ).then((updatedPages) => {
        this.listLinkPage = updatedPages;
      })
    });
  }

  /**
   * Bắt sự kiện thay đổi các trường trong from
   */
  onChangeAttr() {
    const menu = this.data.childMenu;

    setTimeout(() => {
      if (!menu) return;

      const isValidBody =
          (menu.type === 'none') ||
          (menu.type === 'link-page' && menu.link_page != null) ||
          (menu.type === 'website' && menu.link_website) ||
          (menu.type === 'link-url' && menu.link_url);

      this.isValid = menu['name_' + this.functionService.selectedLanguageCode] && (isValidBody);
    }, 50)
  }

  /**
   * Lưu giá trị form chỉnh sửa menu con và truyền về đi giao diện hiển thị
   */
  saveValueDataEdit() {
    // Xóa các trường không cần
    const menu = this.data.childMenu;
    // Xóa theo type
    const typeFieldsToDeleteMap = {
      'none': ['link_page', 'link_website', 'link_url'],
      'link-page': ['link_website', 'link_url'],
      'website': ['link_page', 'link_url'],
      'link-url': ['link_website', 'link_page']
    };
    // Xóa theo group
    const groupFieldsToDeleteMap = {
      'link': ['id_page_category', 'id_freeblock'],
      'category': ['id_freeblock'],
      'pop-up': ['id_page_category']
    };
    // Mảng chứa các trường cần xóa
    const fieldsToDelete = typeFieldsToDeleteMap[menu.type] || [];
    fieldsToDelete.push(...groupFieldsToDeleteMap[menu.group] || []);
    // Xóa
    this.deleteFields(menu, fieldsToDelete);
    
    this.valueDataEdit.emit(this.data);
    this.isCancelFormEditSub.emit(false);
  }

  /**
   * Xóa các trường trong object
   * @param {Object} data - Object có trường cần xóa
   * @param {Array} fieldsToDelete - Mảng chứa tên các trường cần xóa
   */
  deleteFields(data, fieldsToDelete) {
    fieldsToDelete.forEach(field => {
      delete data[field];
    });
  }

  /**
   * Đóng form sửa menu con
   */
  cancelFormEditSub() {
    this.isCancelFormEditSub.emit(false);
  }
  
}
